import Flex from 'mrf/layout/Flex';
import Text from 'mrf/layout/Text';
import React from 'react';
import { ForbiddenIcon } from 'styles/components/Icons';
import Paper from './Paper';
import TextIcon from './TextIcon';

export default function Status403Forbidden({ roleCodes = [] }) {
    return (
        <Flex className='h-full -mt-4' justify='center' align='start'>
            <Paper className='text-center'>
                <Flex align='center' direction='col' width='full'>
                    <Flex justify='center' align='center'>
                        <TextIcon icon={ForbiddenIcon} size={8} />
                        <Text className='block text-3xl' align='center'>
                            403 Forbidden!
                        </Text>
                    </Flex>
                    <span>
                    <Text>To access this page you need the roles</Text> "{roleCodes?.join('", "')}"
                    </span>
                </Flex>
            </Paper>
        </Flex>
    );
}
